export default __webpack_public_path__ + "99f63ae7a743f21ab30847ed06a698d9.png";